import { MatchingOverview } from '../translations-types';

const translations: MatchingOverview = {
  dateTime: 'Date/time',
  appointment: 'Appointment',
  status: 'Status',
  customer: 'Customer',
  voorzorg: 'Before care',
  nazorg: 'After care',
  matched: 'Linked',
  unmatched: 'Not linked',
  ambiguous: 'Multiple matches',
  noAttendee: 'No name',
  noResults: 'No appointments in the last 7 days.',
};

export default translations;
